export const queryName = {
  LOGIN: "login",
  SUGGESTION: "suggestion",
  SERVICES: "services",
  SUGGESTION_ONE: "suggestionOne",
  GENERETED_PDF: "generetedPDF",
  DEFINITION: "definition"
};
